import script from "./TeacherStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherStudents.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./TeacherStudents.vue?vue&type=style&index=1&id=515c79f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-515c79f6"]])

export default __exports__